import { apiFetch } from "@/api/APIClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface UpdateUserTestSettingsParams {
  userId: string;
  testPaymentEnabled: boolean;
}

export function useUpdateUserTestSettings() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateUserTestSettingsParams>({
    mutationFn: async ({ userId, testPaymentEnabled }) => {
      const response = await apiFetch(`api/admin/users/${userId}/test-settings`, {
        method: "PATCH",
        body: JSON.stringify({ testPaymentEnabled }),
      });

      if (!response.ok) {
        throw new Error("테스트 결제 설정을 변경하지 못했습니다.");
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-users"] });
    },
  });
}
